import { createSelector } from "reselect";

export const getMuted = (state) => state.UIState.muted;

export const getInfoUrlImage = (state) => state.UIState.urlImage;

export const getInfoName = (state) => state.UIState.nameTinode;

export const getAssetType = (state) => state?.UIState?.assetType ||"USDC";

export const getTimeStampTimer = (state) => state.UIState.timeStamp;

export const getHamburgerStateOpen = (state) => state.UIState.hamburgerStateOpen;

export const getProfileSettingOpen = (state) => state.UIState.profileSettingOpen;

export const getOrderManagerOpen = (state) => state.UIState.orderManagerOpen;

export const getWidgetContainerOpen = (state) => state.UIState.widgetContainerOpen;

export const getBladeStateOpen = (state) => state.UIState.bladeStateOpen;

export const getTickerType = (state) => state.UIState.tickerType;

export const getDefaultTab = (state) => state.UIState.defaultTab;

export const getEmailRegister = (state) => state.UIState.emailRegister;

const getFCookies = (state) => state.UIState.FCookiesAccepted;
const getTCookies = (state) => state.UIState.TCookiesAccepted;
const getPCookies = (state) => state.UIState.PCookiesAccepted;
const getSCookies = (state) => state.UIState.SCookiesAccepted;

export const getCookiesAccepted = createSelector(
    getFCookies,
    getTCookies,
    getPCookies,
    getSCookies,
    (FCookiesAccepted, TCookiesAccepted,PCookiesAccepted,SCookiesAccepted) => {
        const CookiesOBJ = {
            'FCookies': FCookiesAccepted,
            'TCookies': TCookiesAccepted,
            'PCookies': PCookiesAccepted,
            'SCookies': SCookiesAccepted
        }
        return CookiesOBJ;
    }
)

